import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { MarketingErrorBoundary } from './MarketingErrorBoundary';
import { SiteDownPage } from './components/SiteDownPage';
import { installSiteDownGuards, navigateToStaticSiteDown } from './siteDown';

installSiteDownGuards();

const el = document.getElementById('root');
if (!el) {
  navigateToStaticSiteDown();
} else {
  const tree = (
    <StrictMode>
      <MarketingErrorBoundary>
        <App />
      </MarketingErrorBoundary>
    </StrictMode>
  );
  try {
    // Every sitemap route ships with its markup already in #root (see copy-spa-shells.mjs), so
    // adopt it rather than clearing and repainting the page the visitor can already see.
    // Anything else — a route with no shell, a dev server — still mounts from empty.
    if (el.firstChild) hydrateRoot(el, tree);
    else createRoot(el).render(tree);
  } catch {
    createRoot(el).render(<SiteDownPage />);
  }
}
